import { createContext, useEffect, useState } from "react";
import { api } from "../api";
import { path } from "../constants";

export const appContext = createContext()

export default function AppProvider(props){
    const [token, setToken] = useState(null)
    const [user, setUser] = useState(null)
    const [notification, setNotification] = useState({})
    const [showSidebar, setShowSidebar] = useState(false)
    const [showTerms, setShowTerms] = useState(false)

    useEffect(() => {
        let _token = localStorage.getItem('hwtoken')
        if(_token) setToken(_token)
    }, [])

    useEffect(() => {
        if(token){
            api.get(path.myAccount).then(response => {
                let data = response.data
                if(data.success) setUser(data.user)
            })
        }
    }, [token])
    
    return (
        <appContext.Provider value={{token, setToken, notification, setNotification, user, setUser, showSidebar, setShowSidebar, showTerms, setShowTerms}}>
            {props.children}
        </appContext.Provider>
    )
}